import {apiService} from '../apiService';
import {GROUP_MEMBERS_TYPE} from '../../constants/GroupMembersType';
import PROFILE_TYPE from '../../constants/profileTypes';

export const profilesService = apiService.injectEndpoints({
    endpoints: (builder) =>
        ({
            getProfiles: builder.query({
                query: ({isParent, filterMembersType, ...body}) =>
                    ({
                        url: filterMembersType === GROUP_MEMBERS_TYPE.employee
                            ? '/employees/list'
                            : isParent
                                ? '/parent/student/list'
                                : '/student/list',
                        method: 'POST',
                        data: body,
                    }),
                transformResponse: (response) => ({
                    ...response,
                    items: response.items?.map(item => ({
                        ...item,
                        isApplicant: item.personType === PROFILE_TYPE.APPLICATION
                    }))
                }),
                transformErrorResponse: (_) => ({message: 'Failed to retrieve profiles'}),
                providesTags: (_) => ['GroupFilters']
            }),
            getContacts: builder.query({
                query: ({
                            isParent,
                            studentId
                        }) => ({url: isParent ? `/parent/student/${studentId}/contact` : `/student/${studentId}/contact`}),
                transformErrorResponse: (_) => ({message: 'Failed to retrieve contacts info'}),
                providesTags: (_) => ['Contacts']
            }),
            // AD-2723: the parent's other children whose profiles also hold this email address
            getOtherChildrenForEmailChange: builder.query({
                query: ({contactId}) => ({url: `/parent/contact/${contactId}/other-children`}),
                transformErrorResponse: (_) => ({message: 'Failed to retrieve the other children'}),
                providesTags: (_) => ['Contacts']
            }),
            // AD-2721: who else at the school lives at the address entered for a new contact (staff only)
            getPeopleAtAddress: builder.query({
                query: ({studentId, houseNumber, houseName, apartment, postcode, udprn, uprn}) => ({
                    url: `/student/${studentId}/contact/people-at-address`,
                    params: {houseNumber, houseName, apartment, postcode, udprn, uprn}
                }),
                transformErrorResponse: (_) => ({message: 'Failed to retrieve the people at this address'})
            }),
            addContact: builder.mutation({
                query: ({studentId, body}) => ({
                    url: `/student/${studentId}/contact`,
                    method: 'POST',
                    data: body,
                }),
                invalidatesTags: ['Contacts']
            }),
            updateContact: builder.mutation({
                query: ({studentId, isParent, body}) => ({
                    url: isParent ? `/parent/student/${studentId}/contact` : `/student/${studentId}/contact`,
                    method: 'PUT',
                    data: body,
                }),
                invalidatesTags: ['Contacts']
            }),
            // AD-2645: Email Notifications and the SIMS boxes, from the envelope on the contact's row
            updateContactPreferences: builder.mutation({
                query: ({studentId, contactId, isParent, body}) => ({
                    url: isParent
                        ? `/parent/student/${studentId}/contact/${contactId}/preferences`
                        : `/student/${studentId}/contact/${contactId}/preferences`,
                    method: 'PUT',
                    data: body,
                }),
                invalidatesTags: ['Contacts']
            }),
            deleteContact: builder.mutation({
                query: ({studentId, contactId}) => ({
                    url: `/student/${studentId}/contact/${contactId}`,
                    method: 'DELETE',
                }),
                invalidatesTags: ['Contacts']
            }),
            manageConfirm: builder.mutation({
                query: ({studentId, type}) => ({
                    url: `/student/${studentId}/confirm`,
                    method: 'PATCH',
                    data: {studentId, type},
                }),
                invalidatesTags: ['Contacts']
            }),
            bulkStatusUpdate: builder.mutation({
                query: (body) => ({
                    url: '/student/bulk-status-update',
                    method: 'POST',
                    data: body,
                }),
                invalidatesTags: ['GroupFilters']
            }),
            getInviteData: builder.query({
                query: ({inviteId}) => ({
                    url: `/account/invite/${inviteId}`
                })
            })
        }),
});

export const {
    useGetProfilesQuery,
    useAddContactMutation,
    useUpdateContactMutation,
    useUpdateContactPreferencesMutation,
    useGetInviteDataQuery,
    useGetContactsQuery,
    useGetOtherChildrenForEmailChangeQuery,
    useGetPeopleAtAddressQuery,
    useManageConfirmMutation,
    useDeleteContactMutation,
    useBulkStatusUpdateMutation
} = profilesService;
